"use client";

import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { GlassCard } from "@/src/components/GlassCard";

// * ─── CTA Section ────────────────────────────────────────────────────────────
export function HomeCtaSection() {
  const { t } = useTranslation("common");

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <GlassCard className="p-12 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-walnut-900 dark:text-white mb-6">
            {t("cta.title")}
          </h2>
          <p className="text-lg text-walnut-700 dark:text-walnut-300 mb-8 max-w-2xl mx-auto">
            {t("cta.subtitle")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/quote"
              className="px-8 py-4 rounded-[33px] bg-gradient-to-r from-walnut-600 to-walnut-700 dark:from-walnut-500 dark:to-walnut-600 text-white font-semibold hover:shadow-lg hover:shadow-walnut-500/30 transition-all duration-300 hover:scale-105 inline-flex items-center justify-center gap-2"
            >
              {t("cta.getQuote")}
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              href="/contact"
              className="px-8 py-4 rounded-[33px] backdrop-blur-xl bg-walnut-100 dark:bg-walnut-800 text-walnut-900 dark:text-white font-semibold hover:bg-walnut-200 dark:hover:bg-walnut-700 transition-all duration-300 hover:scale-105"
            >
              {t("cta.contactUs")}
            </Link>
          </div>
        </GlassCard>
      </div>
    </section>
  );
}
